import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function FavoritesPage() {
  const { user, refresh } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/favorites").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const toggleFav = async (id) => {
    try { await api.post(`/favorites/${id}`); await refresh(); load(); }
    catch { toast.error("Could not update"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
      <p className="label-eyebrow text-gray-500 mb-2">Your saved homes</p>
      <h1 className="font-display text-4xl sm:text-5xl brand-forest mb-10">Favorites</h1>
      {loading ? (
        <div className="text-center py-20 text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-brand-subtle">
          <p className="text-gray-500">No saved properties yet — tap the heart on any listing to save it here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((p) => (
            <PropertyCard key={p.id} property={p} isFav={user?.favorites?.includes(p.id)} onToggleFav={toggleFav} />
          ))}
        </div>
      )}
    </div>
  );
}
